import React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import { Switch, Route } from "react-router-dom";
import { ShellProps } from "../ModuleProps";
import { AppBar } from "./AppBar";
import { useSelector } from "react-redux";
import { theme } from "./theme";
import { Container } from "@material-ui/core";

// this layout is taken from https://material-ui.com/components/drawers/#responsive-drawer
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contentHeightShim: {
      paddingTop: theme.contentOffsets.AFTER_MAIN_APPBAR,
    },
    content: {
      // flexGrow: 1,
      // padding: theme.spacing(3),
    },
    menuSection: {
      marginBottom: 15,
    },
    container: {},
  })
);

export const LayoutLite: React.FC<ShellProps> = ({
  items = [],
  toolbarItems = [],
  coreItems = [],
}) => {
  const classes = useStyles();
  const [isMobileOpen, setIsMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setIsMobileOpen(!isMobileOpen); 
  };

  const user = useSelector((state: any) => state.auth.user);

  // in 'Lite' mode we do not have a menu taking up space on the right, so we set to zero
  //  the mainDrawerWidth property which other components pick up from the theme
  const overiddenTheme = {
    ...theme,
    layoutDimensions: { ...theme.layoutDimensions, mainDrawerWidth: 0 },
  };

  return (
    <MuiThemeProvider theme={overiddenTheme}>
      <div className={`${classes.root} Root`}>
        <AppBar
          handleDrawerToggle={handleDrawerToggle}
          toolbarItems={toolbarItems}
        ></AppBar>
        <Container maxWidth="xl" className={classes.container}>
          <main className={classes.content}>
            <div className={classes.contentHeightShim} />
            <Switch>
              {items.map((item) => {
                return (
                  item &&
                  item.module &&
                  (item.visibility(user) ||
                    (!item.visibility(user) &&
                      item.loadWhenInvisible &&
                      item.loadWhenInvisible(user))) && (
                    <Route
                      key={item.pathOrUrl}
                      path={item.pathOrUrl}
                      exact={!!item.exactPathMatch}
                    >
                      <item.module.component />
                    </Route>
                  )
                );
              })}
            </Switch>
          </main>
        </Container>
      </div>
    </MuiThemeProvider>
  );
};
